export interface NavItem {
  id: string;
  label: string;
}

export const navItems: NavItem[] = [
  { id: 'rankings', label: '热榜排行' },
  { id: 'reviews', label: '深度测评' },
  { id: 'compare', label: '风格对比' },
  { id: 'gossip', label: '吃瓜速递' },
  { id: 'tips', label: '避雷清单' },
  { id: 'faq', label: '常见问题' },
];

export interface Category {
  icon: string;
  name: string;
  desc: string;
  target: string;
}

export const categories: Category[] = [
  { icon: 'ri-trophy-line', name: '排行盘点', desc: '每期榜单用同一套口径更新，谁上谁下清清楚楚', target: 'rankings' },
  { icon: 'ri-eye-line', name: '深度测评', desc: '同一场主题横向实测，只聊干货和真实表现', target: 'reviews' },
  { icon: 'ri-scales-line', name: '风格对比', desc: '带看型、解析型、应急型，定位相似博主放一起比', target: 'compare' },
  { icon: 'ri-fire-line', name: '吃瓜速递', desc: '更新动态、翻车现场、争议话题，跟上热点不迷路', target: 'gossip' },
  { icon: 'ri-shield-check-line', name: '避雷清单', desc: '把套路话术和低质内容筛出来，帮你少走弯路', target: 'tips' },
  { icon: 'ri-question-line', name: '答疑解惑', desc: '选号、入坑、怎么用，常见问题一次说清', target: 'faq' },
];

export interface RankingItem {
  rank: number;
  name: string;
  platform: string;
  tag: string;
  fans: string;
  score: number;
  trend: 'up' | 'down' | 'flat';
  summary: string;
}

export const hotRanking: RankingItem[] = [
  { rank: 1, name: '老K高情商', platform: '抖音', tag: '涨粉黑马', fans: '202万', score: 92, trend: 'up', summary: '话题度拉满、更新最勤，场面话术多但下限不稳。' },
  { rank: 2, name: '桔梗会聊天', platform: '抖音', tag: '聊天节奏', fans: '156万', score: 90, trend: 'flat', summary: '把「接话」讲成节奏课，跨性别视角评分常青。' },
  { rank: 3, name: '老周开腔', platform: '抖音', tag: '实战带看', fans: '127万', score: 89, trend: 'up', summary: '街头实拍量大，勇气与真诚派代表，适合胆小的看。' },
  { rank: 4, name: '阿泽社交课', platform: '小红书', tag: '高情商', fans: '92万', score: 87, trend: 'flat', summary: '场景话术颗粒度细，被抄最多也最耐看的一位。' },
  { rank: 5, name: '木子不冷场', platform: '小红书', tag: '实用应急', fans: '110万', score: 86, trend: 'up', summary: '冷场急救百科，地铁搭话名场面稳定输出。' },
  { rank: 6, name: '一凡搭讪手记', platform: 'B站', tag: '复盘解析', fans: '68万', score: 84, trend: 'flat', summary: '逐帧复盘失败案例，理性挂博主里的宝藏。' },
  { rank: 7, name: '南风识人', platform: '视频号', tag: '心理洞察', fans: '45万', score: 82, trend: 'down', summary: '微表情与读心向，理念新但案例样本偏少。' },
  { rank: 8, name: '苏小满', platform: 'B站', tag: '女生向表达', fans: '33万', score: 79, trend: 'down', summary: '站在被搭讪一方拆反馈，适合补短板的小众视角。' },
];

export type RankTab = 'all' | 'rising' | 'stable';

export interface ReviewItem {
  id: string;
  name: string;
  platform: string;
  fans: string;
  score: number;
  badge: string;
  topic: string;
  avatarHue: string;
  tagline: string;
  pros: string[];
  cons: string[];
  suited: string;
  verdict: string;
}

export const reviewList: ReviewItem[] = [
  {
    id: 'laok',
    name: '老K高情商',
    platform: '抖音',
    fans: '202万',
    score: 92,
    badge: '本期争议之王',
    topic: '社交表达·场面话',
    avatarHue: 'bg-primary-500',
    tagline: '更新像追剧，翻车像连续剧，是「吃瓜素材库」也是「话术试验田」。',
    pros: ['更新频率断层第一，热点反应快', '开场白花样多，可直接抄作业', '账号话题度高，互动氛围活跃'],
    cons: ['部分话术油腻、语境适配要求高', '实操翻车案例不少，需自行过滤', '人设感重，方法论偏碎不成体系'],
    suited: '喜欢追更新、想要丰富开场库存、不排斥娱乐化表达的人。',
    verdict: '推荐指数高但需理智追更：看热闹容易，落地要自己挑着用。',
  },
  {
    id: 'jiegeng',
    name: '桔梗会聊天',
    platform: '抖音',
    fans: '156万',
    score: 90,
    badge: '跨性别视角标杆',
    topic: '聊天节奏·接话',
    avatarHue: 'bg-accent-600',
    tagline: '少讲「怎么开口」，多讲「怎么让对方愿意接」，方向很正。',
    pros: ['从对方感受出发，观念友好', '把接话拆成节奏，可操作性强', '评论区答疑质量高，互动真实'],
    cons: ['单集信息密度偏低，需连续追', '偏观念输出，硬干货相对少', '广告植入略频繁，影响观感'],
    suited: '想提升聊天舒适度、避免尬聊冷场、重视双方感受的人。',
    verdict: '三观在线的一位，适合长期跟更，作为「表达审美」启蒙不错。',
  },
  {
    id: 'laozhou',
    name: '老周开腔',
    platform: '抖音',
    fans: '127万',
    score: 89,
    badge: '实战勇气派',
    topic: '街头实拍·搭话',
    avatarHue: 'bg-secondary-600',
    tagline: '实拍不修、失败也不剪，真实感是它的最大招牌。',
    pros: ['实拍量大且保留失败镜头，够真实', '反焦虑属性强，治愈社恐', '话术接地气，没架子'],
    cons: ['画面与收音粗糙，制作一般', '题材单一，看多易重复', '个体样本不代表普遍结果'],
    suited: '害怕被拒绝、需要先看「别人也失败过」再上场的观众。',
    verdict: '论勇气与真诚值得一赞，是建立心理预期的入门好选择。',
  },
];

export interface CompareSide {
  name: string;
  platform: string;
  style: string;
}

export interface CompareGroup {
  title: string;
  subtitle: string;
  rows: { label: string; left: string; right: string }[];
  left: CompareSide;
  right: CompareSide;
}

export const compareGroups: CompareGroup[] = [
  {
    title: '实战带看型：老K vs 老周',
    subtitle: '同为街头实战大户，一个「剧本感重」，一个「纪录感强」。',
    left: { name: '老K高情商', platform: '抖音', style: '综艺向·强人设' },
    right: { name: '老周开腔', platform: '抖音', style: '纪录向·重真实' },
    rows: [
      { label: '内容定位', left: '社交表达与场面话', right: '街头实拍搭话记录' },
      { label: '更新频率', left: '高频，热点敏感', right: '中频，实拍周期长' },
      { label: '真实度', left: '偏剧本编排', right: '含失败镜头更真实' },
      { label: '可复制性', left: '单点话术好抄', right: '勇气心态更好学' },
      { label: '观看门槛', left: '低，娱乐性强', right: '低，治愈向' },
      { label: '主要槽点', left: '油腻与翻车并存', right: '题材重复、制作粗' },
      { label: '综合评分', left: '92', right: '89' },
    ],
  },
  {
    title: '解析提升型：阿泽 vs 一凡',
    subtitle: '一个拆「话怎么说」，一个拆「为什么失败」，正好互补。',
    left: { name: '阿泽社交课', platform: '小红书', style: '场景话术·方法论' },
    right: { name: '一凡搭讪手记', platform: 'B站', style: '失败复盘·理性向' },
    rows: [
      { label: '内容定位', left: '场景话术方法论', right: '失败案例逐帧复盘' },
      { label: '内容形态', left: '短图文+切片', right: '长视频深度分析' },
      { label: '干货密度', left: '中高，话术成体系', right: '高，逻辑性强' },
      { label: '学习门槛', left: '中等', right: '较高，需耐心' },
      { label: '适合人群', left: '想要「说什么」', right: '想知道「为什么错」' },
      { label: '主要槽点', left: '被搬运抄袭重灾区', right: '更新慢、冷门' },
      { label: '综合评分', left: '87', right: '84' },
    ],
  },
  {
    title: '应急实用型：木子 vs 桔梗',
    subtitle: '都在解决「开口之后冷场」，一个给急救包，一个给节奏感。',
    left: { name: '木子不冷场', platform: '小红书', style: '冷场急救·实用' },
    right: { name: '桔梗会聊天', platform: '抖音', style: '接话节奏·观念' },
    rows: [
      { label: '内容定位', left: '冷场化解应急包', right: '聊天节奏与接话' },
      { label: '内容形态', left: '场景条+清单', right: '观念短视频+直播' },
      { label: '上手难度', left: '极低，拿来就用', right: '中，需内化' },
      { label: '深度', left: '偏浅，覆盖广', right: '偏理念，持久性好' },
      { label: '适合人群', left: '马上要用的人', right: '想长期提升的人' },
      { label: '主要槽点', left: '套路化易撞车', right: '单集信息少' },
      { label: '综合评分', left: '86', right: '90' },
    ],
  },
];

export interface GossipItem {
  date: string;
  tag: string;
  tone: 'hot' | 'new' | 'flip' | 'normal';
  title: string;
  desc: string;
}

export const gossipList: GossipItem[] = [
  { date: '06-21', tag: '热点', tone: 'hot', title: '老K「机场开场」翻车名场面被剪成合集', desc: '一句预设过头的开场白引发评论区两极，有人吐槽剧本感重，也有人认为话题度拉满。' },
  { date: '06-18', tag: '动态', tone: 'new', title: '桔梗开启「接话训练营」月度答疑直播', desc: '从留言中抽选真实对话做即时拆解，被不少粉丝评为「含金量最高的一期」。' },
  { date: '06-15', tag: '盘点', tone: 'flip', title: '「抄话术」撞车事件：多个切片被指同源', desc: '同一句开场白在一周内出现在多个头部账号，搬运现象再被搬上台面。' },
  { date: '06-12', tag: '榜单', tone: 'normal', title: '六月「值得关注」名单更新：实战派回暖', desc: '结合近一月更新质量，老周与木子的综合热度稳步上升，理性型博主关注度走高。' },
  { date: '06-09', tag: '翻车', tone: 'flip', title: '套路「欲擒故纵」翻车实录被博主自嘲式回应', desc: '有创作者主动承认话术不适用人群，并补了一期「这些话术别乱用」的避雷内容。' },
  { date: '06-05', tag: '观点', tone: 'normal', title: '编辑部观察：搭话内容正在从「术」转向「道」', desc: '越来越多创作者开始谈尊重、边界与舒适感，题材转向肉眼可见。' },
];

export interface TipItem {
  title: string;
  level: 'high' | 'mid' | 'low';
  desc: string;
}

export const tipList: TipItem[] = [
  { title: '只拍「成功」不拍「失败」', level: 'high', desc: '全程高光、零翻车的内容大概率经过大量剪辑，样本参考价值有限。' },
  { title: '强调「让对方买单」的话术', level: 'high', desc: '以消费、请客、送礼为核心的套路，往往把人当成猎物，建议直接划走。' },
  { title: '贩卖焦虑的「必学神技」', level: 'high', desc: '把聊天讲成玄学、宣称学不会就没社交的，多半在收割注意力。' },
  { title: '无版权搬运的「混剪合集」', level: 'mid', desc: '把别人原话换脸重剪，风格乱且出处不明，版权与可信度都存疑。' },
  { title: '评论区疯狂私信带课', level: 'mid', desc: '正文免费、评论私信推销高价课的账号，谨防付费内容与账号人设不符。' },
  { title: '人设前后反复横跳', level: 'low', desc: '从技术流突转情感主播、反复改定位的账号，内容稳定性往往打折扣。' },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqList: FaqItem[] = [
  { q: '搭讪吃瓜到底是做什么的？', a: '我们是聚焦搭讪、社交表达与搭话内容创作者的内容观察站。围绕「测评、盘点、排行、对比、吐槽避雷」五个维度，用同一套口径持续跟踪博主更新，帮你判断谁值得关注、谁的坑可以绕开。' },
  { q: '你们的排行评分口径是什么？', a: '综合「内容真实度、方法论可复制性、更新稳定性、互动口碑与翻车率」五个维度，按近 30 天表现滚动更新，分高分低只代表近期表现，不代表永久结论。' },
  { q: '榜单会不会被商业化影响？', a: '不会。目前我们不接任何以改分换排名为目的的商务合作，榜单基于公开内容与编辑部独立观测，涉及付费推广的内容会单独标注。' },
  { q: '为什么有的博主评分和大众印象不一样？', a: '热门账号话题度高但翻车也多，我们更看重「长期稳定」而非「短期流量」，所以部分热闹账号评分不会虚高，这也是避雷的意义所在。' },
  { q: '搭话内容要怎么选号入门？', a: '建议先看「复盘解析型」建立判断力，再看「实战带看型」降低心理预期，最后用「应急实用型」解决具体场景，三步下来基本能找到适合自己的那位。' },
  { q: '你们能提供一对一付费咨询吗？', a: '不能，也不建议。搭话与社交表达没有统一答案，与其花高价买「神技」，不如多跟观念友好、敢发失败案例的免费博主，练自己的判断力更靠谱。' },
];

export interface VoiceItem {
  quote: string;
  name: string;
  role: string;
}

export const voiceList: VoiceItem[] = [
  { quote: '看了三期深度测评入坑，发现之前跟了好几个号都在原地打转，现在知道该看谁了。', name: '一位追更半年的读者', role: '排行榜评论区' },
  { quote: '避雷清单救了大命，原来我关注的号一直是被搬运重灾区，终于有人把这层窗户纸捅破了。', name: '吃瓜群的A同学', role: '避雷清单反馈' },
  { quote: '最难得的是它敢把「翻车」也剪进盘点，这种不端着的内容在搭讪话题里真不多见。', name: '新手村入坑观众', role: '实测评论' },
  { quote: '没有急着卖课、也没有神化某位博主，看完能自己拿主意，这点很加分。', name: '长期潜水用户', role: '站内留言' },
];

export const siteMeta = {
  brand: '搭讪吃瓜',
  tagline: '把搭讪博主，一个一个翻个明白',
  desc: '测评 · 盘点 · 排行 · 对比 · 吐槽避雷',
  updatedAt: '2026-06-21',
};